export const isMobile = (): boolean => window.innerWidth >= 769
